import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";

export const uploadPreOnboardingDocs = createAsyncThunk('candidate/uploadPreOnboardingDocs',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosPrivate.post(api.uploadPreOnboardingDocs, payload, {
        headers: {
          'custom-auth-type': 'token'
        }
      });
      return response.data;
    } catch(error) {
      return rejectWithValue(error?.response?.data?.message || "Unable to connect to server");
    }
  })

const preonboardingDocsUploadSlice = createSlice({
  name: 'uploadPreOnboardingDocs',
  initialState: {
    uploadPreOnboardingDocs: [],
    uploadPreOnboardingDocsStatus: 'idle',
    uploadPreOnboardingDocsLoading: false,
    uploadPreOnboardingDocsError: null
  },
  reducers: {},
  extraReducers: (builders) => {
    builders
      .addCase(uploadPreOnboardingDocs.pending,
        (state) => {
          state.uploadPreOnboardingDocsStatus = 'loading';
          state.uploadPreOnboardingDocsLoading = true;
          state.uploadPreOnboardingDocsError = null;
        })
      .addCase(uploadPreOnboardingDocs.fulfilled,
        (state, action) => {
          state.uploadPreOnboardingDocsStatus = 'succeeded';
          state.uploadPreOnboardingDocsLoading = false;
          state.uploadPreOnboardingDocs = action.payload;
        })
      .addCase(uploadPreOnboardingDocs.rejected,
        (state, action) => {
          state.uploadPreOnboardingDocsStatus = 'failed';
          state.uploadPreOnboardingDocsLoading = false;
          state.uploadPreOnboardingDocsError = action.payload;
        }
      )
  }
})

export default preonboardingDocsUploadSlice.reducer;